/**
 * Stil der Oberfläche: eine wählbare Optik, unabhängig von Hell/Dunkel.
 * Derselbe Schalter wie im Portal (cloud-v2 `lib/stil.ts`), damit die Wahl
 * später über die Benutzereinstellungen mitreist (Post #5421).
 *
 * „V2“ ist die content-app, wie sie bis 13.10.2026 aussah (Roboto, Etiketten
 * in Großbuchstaben, eckig). „V3“ ist der Stil von Cloud-Marketing (Vergleich
 * in Post #5372): Google Sans Flex, normale Schreibung, Raster 12/13/15/18/24,
 * leichte Rundung, Blau. Der Stil steht als `data-stil` an <html>; V2 ist der
 * Grundzustand der Stylesheets, `styles/stil-v3.css` überschreibt nur unter
 * `[data-stil="v3"]`.
 */
export type Stil = 'v2' | 'v3'

export const STIL_SCHLUESSEL = 'cloud-v2-stil'
/** Seit 11.10.2026 ist V3 die Vorgabe (Alex); wer V2 gewählt hat, behält V2. */
export const STIL_VORGABE: Stil = 'v3'
export const STIL_EREIGNIS = 'cloud-stil-change'
export const STILE: ReadonlyArray<{ id: Stil; name: string; hinweis: string }> = [
  { id: 'v2', name: 'V2', hinweis: 'Bisherige Optik: eckig, Etiketten in Großbuchstaben' },
  { id: 'v3', name: 'V3', hinweis: 'Neue Optik: Google Sans, normale Schreibung, leichte Rundung, Blau' },
]

export function liesStil(wert: string | null | undefined): Stil {
  return wert === 'v2' || wert === 'v3' ? wert : STIL_VORGABE
}

export function getStil(): Stil {
  try { return liesStil(localStorage.getItem(STIL_SCHLUESSEL)) } catch { return STIL_VORGABE }
}

export function applyStil(stil: Stil): void {
  document.documentElement.setAttribute('data-stil', stil)
}

/** Merken, anwenden und melden. */
export function setStil(stil: Stil): void {
  try { localStorage.setItem(STIL_SCHLUESSEL, stil) } catch { /* voll */ }
  applyStil(stil)
  window.dispatchEvent(new CustomEvent(STIL_EREIGNIS, { detail: stil }))
}

const hoerer = new Set<() => void>()
export function stilAbonnieren(fn: () => void): () => void {
  const weiter = () => fn()
  window.addEventListener(STIL_EREIGNIS, weiter)
  window.addEventListener('storage', weiter)
  hoerer.add(fn)
  return () => { window.removeEventListener(STIL_EREIGNIS, weiter); window.removeEventListener('storage', weiter); hoerer.delete(fn) }
}
